import { z } from "zod";
import { EXPERIMENT_ENTITY_PREFIX, isValidPrefixedKsuid } from "@/utils/ksuidGenerator";
import { parseCatalogEntityPayload } from "@/lib/toolCardSchemas/parseCatalogEntityPayload";

const prefixedKsuid = (prefix: string, label: string) =>
  z.string().refine((id) => isValidPrefixedKsuid(id, prefix), {
    message: `Invalid ${label} public ID`,
  });

export const MarkCompletePayloadSchema = z.object({
  experimentPublicId: prefixedKsuid(EXPERIMENT_ENTITY_PREFIX, "experiment"),
  experimentTitle: z.string().min(1).optional(),
});

export const MarkCompleteResolveSchema = z.object({});

export type MarkCompletePayload = z.infer<typeof MarkCompletePayloadSchema>;
export type MarkCompleteResolve = z.infer<typeof MarkCompleteResolveSchema>;

export type MarkCompleteToolResult = {
  toolCallId: string;
};

export type MarkCompleteArgs = {
  entities?: Array<{
    type?: string;
    experimentPublicId?: string;
    experimentTitle?: string;
    toolInvoke?: { toolCallId?: string };
  }>;
  experimentPublicId?: string;
  experimentTitle?: string;
};

export function parseMarkCompletePayload(args: unknown, toolCallId?: string) {
  return parseCatalogEntityPayload(
    MarkCompletePayloadSchema,
    "mark_complete",
    args,
    toolCallId,
    (entity) => ({
      experimentPublicId: entity.experimentPublicId,
      experimentTitle: entity.experimentTitle,
    }),
  );
}
